import { 
    DELETE_SERVICE_SUCCESS,
    DELETE_SERVICE_FAIL,
    DELETE_SERVICE_DATA_LOADING,
    DELETE_SERVICE_FEATURE_LOADING,
    DELETE_SERVICE_FEATURE_SUCCESS,
    DELETE_SERVICE_FEATURE_FAIL,
} from '../actions/types';
import { axiosInstance } from '../axiosInstance';
import { returnErrors } from '../actions/errorActions';

// DELETE Service Item

export const deleteserviceitem = ({ id }) => (dispatch, getState) => {
    // Data Loading
    dispatch({
        type: DELETE_SERVICE_DATA_LOADING
    });
    axiosInstance.delete(`/api/services?id=${id}`, tokenConfig(getState))
    .then( res => 
        dispatch ({
            type: DELETE_SERVICE_SUCCESS,
            payload: res.data
        })
    )
    .catch(error => {
        if (error.response && error.response.data) {
            dispatch(returnErrors(error.response.data, error.response.status, 'DELETE_SERVICE_FAIL'))
            dispatch ({ 
                type: DELETE_SERVICE_FAIL 
            })
        }else{
            let errorJson = JSON.stringify(error);
            let errorParsed = JSON.parse(errorJson);
            return (
                dispatch(returnErrors(errorParsed.message, "Network Error", 'DELETE_SERVICE_FAIL')),
                dispatch ({ 
                    type: DELETE_SERVICE_FAIL 
                })
            )
        }
    });
};

export const deleteServiceFeature = ({ id }) => (dispatch, getState) => {
    dispatch({
        type: DELETE_SERVICE_FEATURE_LOADING
    });
    axiosInstance.delete(`/api/services/features?id=${id}`, tokenConfig(getState))
    .then( res => 
        dispatch ({
            type: DELETE_SERVICE_FEATURE_SUCCESS,
            payload: res.data
        })
    )
    .catch(error => {
        if (error.response && error.response.data) {
            dispatch(returnErrors(error.response.data, error.response.status, 'DELETE_SERVICE_FEATURE_FAIL'))
            dispatch ({ 
                type: DELETE_SERVICE_FEATURE_FAIL 
            })
        }else{
            let errorJson = JSON.stringify(error);
            let errorParsed = JSON.parse(errorJson);
            return (
                dispatch(returnErrors(errorParsed.message, "Network Error", 'DELETE_SERVICE_FEATURE_FAIL')),
                dispatch ({ 
                    type: DELETE_SERVICE_FEATURE_FAIL 
                })
            )
        }
    });
}


// Setup config/headers and token

export const tokenConfig = getState => {
    // Get token from localStorage
    const token = getState().auth.token;
    //Headers
    const config = {
        headers: {
            "Content-type": "application/json"
        }
    }

    // If token, add to headers

    if (token) {
        config.headers['Authorization'] = 'bearer' + token;
    }

    return config;

}